/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IPriceProvidersRepository,
  IPriceProvidersRepositoryInterface,
} from "../IPriceProvidersRepository";

const _abi = [
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract IPriceProvider",
        name: "newPriceProvider",
        type: "address",
      },
    ],
    name: "NewPriceProvider",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "address",
        name: "asset",
        type: "address",
      },
      {
        indexed: true,
        internalType: "contract IPriceProvider",
        name: "priceProvider",
        type: "address",
      },
    ],
    name: "PriceProviderForAsset",
    type: "event",
  },
  {
    anonymous: false,
    inputs: [
      {
        indexed: true,
        internalType: "contract IPriceProvider",
        name: "priceProvider",
        type: "address",
      },
    ],
    name: "PriceProviderRemoved",
    type: "event",
  },
  {
    inputs: [
      {
        internalType: "contract IPriceProvider",
        name: "_priceProvider",
        type: "address",
      },
    ],
    name: "addPriceProvider",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "getPrice",
    outputs: [
      {
        internalType: "uint256",
        name: "price",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IPriceProvider",
        name: "_provider",
        type: "address",
      },
    ],
    name: "isPriceProvider",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "manager",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "priceProviders",
    outputs: [
      {
        internalType: "contract IPriceProvider",
        name: "priceProvider",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "priceProvidersRepositoryPing",
    outputs: [
      {
        internalType: "bytes4",
        name: "",
        type: "bytes4",
      },
    ],
    stateMutability: "pure",
    type: "function",
  },
  {
    inputs: [],
    name: "providerList",
    outputs: [
      {
        internalType: "address[]",
        name: "",
        type: "address[]",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "providersCount",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
    ],
    name: "providersReadyForAsset",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [],
    name: "quoteToken",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "contract IPriceProvider",
        name: "_priceProvider",
        type: "address",
      },
    ],
    name: "removePriceProvider",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_asset",
        type: "address",
      },
      {
        internalType: "contract IPriceProvider",
        name: "_priceProvider",
        type: "address",
      },
    ],
    name: "setPriceProviderForAsset",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
];

export class IPriceProvidersRepository__factory {
  static readonly abi = _abi;
  static createInterface(): IPriceProvidersRepositoryInterface {
    return new utils.Interface(_abi) as IPriceProvidersRepositoryInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IPriceProvidersRepository {
    return new Contract(
      address,
      _abi,
      signerOrProvider
    ) as IPriceProvidersRepository;
  }
}
